import { Box, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import FeedUpsellImg from "@app/analytics/assets/home/feed_upsell.png";

import Button from "@rui/Button";
import { Column, Row } from "@rui/Stack";

const Wrapper = styled(Row)(({ theme }) => ({
  width: "100%",
  maxWidth: "490px",
  padding: theme.spacing(1.5, 3),
}));

const FeedUpsell = ({
  title,
  description,
  imgSrc = FeedUpsellImg,
  cta,
}: {
  title: string;
  description: string;
  imgSrc?: string;
  cta: { label: string; href: string };
}) => {
  return (
    <Wrapper variant="left" spacing={2}>
      <Box
        component="img"
        src={imgSrc}
        height="120px"
        width="120px"
        borderRadius="16px"
      />
      <Column variant="left" spacing={2}>
        <Column spacing={0.5}>
          <Typography variant="h3" fontWeight={500} color="shades.neutral.800">
            {title}
          </Typography>
          <Typography variant="bodySecondaryReg" color="shades.neutral.700">
            {description}
          </Typography>
        </Column>
        <Button href={cta.href}>{cta.label}</Button>
      </Column>
    </Wrapper>
  );
};

export default FeedUpsell;
